import NeedLoginDialog from '@/features/sections/subscription/need-login/need-login-dialog';
import PaywallDialog from '@/features/sections/subscription/paywall/paywall-dialog';
import { usePopup } from '@/features/stores/popup-store';

function PopupTemplate() {
  const { type, open } = usePopup();

  if (type === 'paywall' && open) {
    return <PaywallDialog />;
  }

  if (type === 'need-login' && open) {
    return <NeedLoginDialog />;
  }
}

export default PopupTemplate;
